import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { BodyText as Text } from 'ui/styles/utils'
import YouTube from 'react-youtube'
import theme from 'ui/styles/theme'
import './styles.css'

export default class ContactVideo extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        loadMedia: false,
        thumbnail: ''
    }

    componentDidMount = () => {
        console.log('component did mount')
            console.log('document is ready');
            if (this.props.img_vid !== "video") {
                this.setState({ loadMedia: true })
            } else {
                this.thumbnailLoader();
            }

        }

    mediaLoader = () => {
        this.setState({ loadMedia: true })
    }

    //Download a thumbnail of a video
    thumbnailLoader = () => {
        let source = "https://img.youtube.com/vi/" + this.props.videoId + "/sddefault.jpg";
        this.setState({ thumbnail: source });
    }




    render() {
        const {
            bgcolor,
            videoId,
            text,
            image,
            img_vid,
            side,
            fit
        } = this.props

        const { loadMedia, thumbnail } = this.state

        const opts = {
            width: '',
            height: '',
            playerVars: {
                // https://developers.google.com/youtube/player_parameters
                autoplay: 1,
            }
        }



        return (
            <Wrapper className={"text-video-container"} bgcolor={bgcolor} >
                <InnerWrapper fluid>
                {/* Contact - Video module section */}
                    {side === 'left' ?
                        <Row>
                            <ExtendedColumn md={6}>
                                <Article dangerouslySetInnerHTML={{ __html: text }} />
                            </ExtendedColumn>
                            <StyledColumn md={6}>
                                {!loadMedia && img_vid === "video" &&
                                    <VidContainer>
                                        <VideoHolder id="video-holder" onClick={this.mediaLoader}>
                                            <img src={thumbnail}></img>
                                            <div className="play-button"></div>
                                        </VideoHolder>
                                    </VidContainer>
                                }
                                {loadMedia &&
                                    <MediaWrapper>
                                        {img_vid === 'video' ? <YouTube opts={opts} videoId={videoId} /> : <Image img={image.sourceUrl} fit={fit}></Image>}
                                    </MediaWrapper>
                                }
                            </StyledColumn>
                        </Row> :
                        <Row>
                            <StyledColumn md={6}>
                                {!loadMedia && img_vid === "video" &&
                                    <VidContainer>
                                        <VideoHolder id="video-holder" onClick={this.mediaLoader}>
                                            <img src={thumbnail}></img>
                                            <div className="play-button"></div>
                                        </VideoHolder>
                                    </VidContainer>
                                }
                                {loadMedia &&
                                    <MediaWrapper>
                                        {img_vid === 'video' ? <YouTube opts={opts} videoId={videoId} /> : <Image img={image.sourceUrl} fit={fit}></Image>}
                                    </MediaWrapper>
                                }
                            </StyledColumn>
                            <ExtendedColumn md={6}>
                                <Article dangerouslySetInnerHTML={{ __html: text }} />
                            </ExtendedColumn>
                        </Row>
                    }

                </InnerWrapper>
            </Wrapper >
        )
    }
}

//Styles
const Wrapper = styled.div`
padding: 0 0px;
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
`
const InnerWrapper = styled(Container)`
padding: 0 20px;
${media.lg`
padding: 0 20%;
`}
`

const VidContainer = styled.section`
display: flex;
align-items: center;
height: 100%;
`

const VideoHolder = styled.section`
background-color: #000;
	overflow: hidden;
	cursor: pointer;
    display: flex;
    justify-content: center;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    top: 0;
    position: relative;
    padding-bottom: 56.25%;

    ${media.md`
    margin-bottom: 30px;
    justify-content: flex-end;
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
    `}



img {
	width: 100%;
	top: -16.84%;
	left: 0;
	opacity: 0.7;
}
.play-button {
	width: 90px;
	height: 60px;
	background-color: #333;
	box-shadow: 0 0 30px rgba( 0,0,0,0.6 );
	z-index: 1;
	opacity: 0.8;
	border-radius: 6px;
    padding: 10px;
    background-color: red;
}

.play-button:hover {
    background-color: #9c0202;
}
.play-button:before {
	content: "";
	border-style: solid;
	border-width: 15px 0 15px 26.0px;
	border-color: transparent transparent transparent #fff;
}
 img, .play-button {
    cursor: pointer;
 }
img, iframe, .play-button, .play-button:before {
    position: absolute;
}
.play-button, .play-button:before {
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
}
iframe {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.play { 
    background: red;
    border-radius: 50% / 10%;
    color: #FFFFFF;
    font-size: 1em; /* change this to change size */
    height: 3em;
    margin: 20px auto;
    padding: 0;
    position: relative;
    text-align: center;
    text-indent: 0.1em;
    transition: all 150ms ease-out;
    width: 4em;
  }
  
  .play:hover {
    background: darkorange;
  }
  
  .play::before { 
    background: inherit;
    border-radius: 5% / 50%;
    bottom: 9%;
    content: "";
    left: -5%;
    position: absolute;
    right: -5%;
    top: 9%;
  }
  
  .play::after {
    border-style: solid;
    border-width: 1em 0 1em 1.732em;
    border-color: transparent transparent transparent rgba(255, 255, 255, 0.75);
    content: ' ';
    font-size: 0.75em;
    height: 0;
    margin: -1em 0 0 -0.75em;
    top: 50%;
    position: absolute;
    width: 0;
  }

`

const MediaButton = styled.button`
`

const Article = styled(Text)`
`
const Image = styled.div`
background: url(${props => props.img}) center;
background-size: ${props => props.fit};
background-repeat: no-repeat;
height: 300px !important;
width: 10px;
overflow: hidden;
`
const MediaWrapper = styled.section`
display: flex;
align-items: center;
height: 100%;
`

const ExtendedColumn = styled(Col)`
padding-top: 10px;
padding-bottom: 10px;
${media.md`
    padding-top: 10px;
    padding-bottom: 10px;
`}
`

const StyledColumn = styled(Col)`
//padding-top: 10px;
padding-bottom: 10px;
${media.md`
//padding-top: 10px;
`}

    div {
        display: flex;
        justify-content: center;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
        top: 0;

        
        ${media.md`
        justify-content: flex-end;
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        height: 0;
        `}
    }

    iframe{
        aspect-ratio: 16/9;
        width: 100%;
        ${media.md`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        `}
    }
${media.lg`
    //padding-top: 50px;
    padding-bottom: 0px;
    padding-right: 20px;
`}
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/TextVideo/index.js